var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdjustinline = function SvgAdjustinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#adjust_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005FF7",
    d: "M8 16.5c4.421 0 8-3.579 8-8s-3.579-8-8-8-8 3.579-8 8 3.579 8 8 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.262 3.994a.783.783 0 0 0-1.398 0L6.01 7.606C1.32 6.124.663 10.318 4.334 12.448a.803.803 0 0 0 1.095-.269c.009-.017.017-.025.025-.042l1.314-2.56c2.13.867 5.145 2.846 5.162 2.855.825.48 1.474-.413 1.137-1.028l-3.806-7.41Zm-4.783 6.602c-.632-.337-2.207-2.434.791-1.55zM7.493 8.17l1.07-2.089 1.819 3.545C9.817 9.316 8.2 8.45 7.493 8.171Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "adjust_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h16v16H0z"
  })))));
};
export default SvgAdjustinline;